import React, { useState, useEffect, Suspense, lazy } from "react";
import Preloader from "./components/Pre";
import Navbar from "./components/Navbar";
import Home from "./components/Home/Home";
import About from "./components/About/About";
import Footer from "./components/Footer";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate
} from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import Xray from "./components/Xray/Xray";
import "./style.css";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

const Projects = lazy(() => import("./components/Projects/Projects"));
const Resume = lazy(() => import("./components/Resume/ResumeNew"));

function App() {
  const [load, upadateLoad] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      upadateLoad(false);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  const basename = (() => {
    if (!process.env.PUBLIC_URL) {
      return "/";
    }

    try {
      const url = new URL(process.env.PUBLIC_URL);
      return url.pathname === "/" ? "/" : url.pathname;
    } catch (err) {
      return process.env.PUBLIC_URL.startsWith("/")
        ? process.env.PUBLIC_URL
        : "/";
    }
  })();

  return (
    <Router basename={basename}>
      <Preloader load={load} />
      <div className="App" id={load ? "no-scroll" : "scroll"}>
        <Navbar />
        <ScrollToTop />
        <Xray />
        <main className="app-main">
          <Suspense fallback={<Preloader load />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/project" element={<Projects />} />
              <Route path="/about" element={<About />} />
              <Route path="/resume" element={<Resume />} />
              <Route path="*" element={<Navigate to="/"/>} />
            </Routes>
          </Suspense>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
